var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Filter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3.5 3 A 0.50005 0.50005 0 0 0 3 3.5195312 L 3.078125 5.4414062 A 0.50005 0.50005 0 0 0 3.2207031 5.7714844 L 10 12.703125 L 10 19.5 A 0.50005 0.50005 0 0 0 10.222656 19.916016 L 13.222656 21.916016 A 0.50005 0.50005 0 0 0 14 21.5 L 14 12.707031 L 20.931641 5.7753906 A 0.50005 0.50005 0 0 0 21.078125 5.4023438 L 21 3.4804688 A 0.50005 0.50005 0 0 0 20.5 3 L 3.5 3 z M 4.0214844 4 L 20.019531 4 L 20.070312 5.2226562 L 13.146484 12.146484 A 0.50005 0.50005 0 0 0 13 12.5 L 13 20.566406 L 11 19.232422 L 11 12.5 A 0.50005 0.50005 0 0 0 10.857422 12.150391 L 4.0703125 5.2089844 L 4.0214844 4 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Filter);
export default __webpack_public_path__ + "static/media/icons8-filter.b1f71cb44dc3f7b9d82b632632c7f6c2.svg";
export { ForwardRef as ReactComponent };